<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">求助电话管理</div>
        <!-- <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="有效状态">
            <el-select v-model="TranresourcesType" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布状态">
            <el-select v-model="TranresourcesType" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布渠道">
            <el-select v-model="TranresourcesType" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公告标题" prop="ResourceName">
            <el-input v-model="ResourceName"></el-input>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form> -->
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                prop="CompanyName"
                label="单位名称"
              ></el-table-column>
              <el-table-column
                prop="CompanyPhone"
                label="举报电话"
              ></el-table-column>
              <el-table-column fixed="right" label="操作" width="160">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <el-button
                    @click="editClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import waitAll from "../../../../../../utils/src/waitAll";
export default {
  name: "CallForHelpList",
  controller: "UI",
  action: "CallForHelpList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      selectData: null,
    };
  },
  created: function() {},
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "求助电话查询";
    this.logInfo.LogMessage = "求助电话查询";
    this.logInfo.ModuleName = "紧急求助";
    this.logInfo.PageName = "求助电话管理列表";
    this.addOperationLog();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      let searchInfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
      };
      new MyApis.TranResourcesApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          //console.log("1");
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    clearsearch() {
      this.TranresourcesType = "";
      this.ResourceName = "";
    },

    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/seekHelp/UI/CallForHelpInfo",
        query: {
          Id: row.Id,
          type: "edit",
        },
      });
    },
    //查看详细
    handleClick(index, row) {
      //console.log(index, row);
      this.$router.push({
        path: "/plugin/seekHelp/UI/CallForHelpInfo",
        query: {
          Id: row.Id,
          type: "look",
        },
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/seekHelp/UI/CallForHelpInfo",
        query: {
          type: "add",
        },
      });
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            console.log("selectData");
            console.log(selectData);
            var arr = [];
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              selectData.forEach((item) => {
                new MyApis.TranResourcesApi()
                  .DelItem(item)
                  .then((r) => {
                    r = r.data.Data;
                    arr.push(r);
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              });
              waitAll(arr)
                .then((r) => {
                  // resolve(r);
                  if (r) {
                    this.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                    this.logInfo.ActionName = "求助电话删除";
                    this.logInfo.LogMessage = "求助电话删除成功";
                    this.logInfo.ModuleName = "紧急求助";
                    this.logInfo.PageName = "求助电话管理列表";
                    this.addOperationLog();
                    this.search();
                  }
                })
                .catch((e) => {
                  // reject(e);
                  if (e) {
                    this.$message({
                      type: "error",
                      message: "删除失败!",
                    });
                  }
                });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！",
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.TranResourcesApi()
            .DelItem(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "求助电话删除";
                this.logInfo.LogMessage = "求助电话删除成功";
                this.logInfo.ModuleName = "紧急求助";
                this.logInfo.PageName = "求助电话管理列表";
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertTranresourcesType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.TranresourcesTypeDic[data];
      return levelstr;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>
